import { Helmet } from 'react-helmet-async';

interface OrganizationSchema {
  '@context': string;
  '@type': string;
  name: string;
  url: string;
  logo: string;
  description: string;
  address?: {
    '@type': string;
    addressLocality: string;
    addressCountry: string;
  };
  contactPoint?: {
    '@type': string;
    contactType: string;
    telephone: string;
  };
}

interface ProductSchema {
  '@context': string;
  '@type': string;
  name: string;
  description: string;
  image: string[];
  offers?: {
    '@type': string;
    price: string;
    priceCurrency: string;
    availability: string;
  };
}

interface StructuredDataProps {
  type?: 'organization' | 'product';
  data?: Partial<ProductSchema>;
}

export function StructuredData({ type = 'organization', data }: StructuredDataProps) {
  const organizationSchema: OrganizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'LocationOran.com',
    url: 'https://locationoran.com',
    logo: 'https://locationoran.com/logo-384.png',
    description: 'Plateforme de location de vacances à Oran - Appartements, villas, voitures et activités',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Oran',
      addressCountry: 'DZ',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      telephone: '+213776043917',
    },
  };

  const productSchema: ProductSchema | undefined = data ? {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: data.name || '',
    description: data.description || '',
    image: data.image || [],
    offers: data.offers || {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'DZD',
      availability: 'https://schema.org/InStock',
    },
  } : undefined;

  const schema = type === 'organization' ? organizationSchema : productSchema;

  if (!schema) return null;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}
